import { Grid, Stack, Typography } from '@mui/material';
import { ChartCard } from '../chart-card';
import { StackedColumns } from '../charts';
import { ReportTable, ShareCell } from '../report-table';
import { inr, num } from '../report-theme';
import { ReportModel } from '../report-data';

export const StaffTab = ({ report }: { report: ReportModel }) => {
	const staff = [...report.staffPerformance].sort((a, b) => (b.totalRevenue ?? 0) - (a.totalRevenue ?? 0));
	const totalRevenue = staff.reduce((sum, member) => sum + (member.totalRevenue ?? 0), 0);
	const leader = staff[0];
	const sellsProducts = staff.some((member) => (member.productRevenue ?? 0) > 0);

	return (
		<Grid container spacing={3}>
			<Grid item xs={12} lg={7}>
				<ChartCard
					title="Revenue by staff member"
					subtitle={
						sellsProducts
							? 'Service and product revenue, stacked per person'
							: leader
								? `${leader.userName} leads with ${inr(leader.totalRevenue)}`
								: 'Revenue booked per person'
					}
					isEmpty={staff.length === 0}
					emptyMessage="No staff activity in the selected period."
				>
					<StackedColumns
						categories={staff.map((member) => member.userName)}
						series={[
							{ name: 'Services', data: staff.map((member) => member.serviceRevenue ?? 0) },
							{ name: 'Products', data: staff.map((member) => member.productRevenue ?? 0) },
						]}
						height={340}
					/>
				</ChartCard>
			</Grid>

			<Grid item xs={12} lg={5}>
				<ChartCard
					title="Performance detail"
					subtitle="Orders handled, average ticket and share of takings"
				>
					<ReportTable
						columns={[
							{
								title: 'Staff',
								render: (row: any) => (
									<Stack>
										<Typography variant="body2" sx={{ fontWeight: 500 }}>
											{row.userName}
										</Typography>
										<Typography variant="caption" color="text.secondary">
											{`${num(row.orderCount)} order${row.orderCount === 1 ? '' : 's'} · avg ${inr(row.averageOrderValue)}`}
										</Typography>
									</Stack>
								),
							},
							{
								title: 'Revenue',
								align: 'right',
								render: (row: any) => (
									<Typography variant="body2" sx={{ fontWeight: 600 }}>
										{inr(row.totalRevenue)}
									</Typography>
								),
							},
							{
								title: 'Share',
								align: 'right',
								width: 140,
								render: (row: any) => (
									<ShareCell
										share={totalRevenue ? ((row.totalRevenue ?? 0) / totalRevenue) * 100 : 0}
									/>
								),
							},
						]}
						rows={staff}
						emptyMessage="No staff activity in the selected period."
						maxHeight={420}
					/>
				</ChartCard>
			</Grid>
		</Grid>
	);
};
